export default {
    methods: {
        getUnitDates(fromDate, endDate, unit) {
            if (unit) {
                let numberOfUnits = Math.ceil(moment(endDate).endOf(unit === 'week' ? 'isoWeek' : unit).diff(moment(fromDate).startOf(unit === 'week' ? 'isoWeek' : unit), unit, true));

                const unitDates = [];
                for (let i = 0; i < numberOfUnits; i++) {
                    const date = moment(fromDate).clone().add(i, unit);
                    unitDates.push(date.toDate())
                }
                return unitDates;
            } else {
                return [new Date()]
            }

        },
        getAvailabilityDataPerDateUnit(availabilityData, fromDate, endDate, unit) {
            const unitDates = this.getUnitDates(fromDate, endDate, unit);
            const availabilityDataPerUnitDate = _.map(unitDates, dateUnit => {
                const correspondingAvailabilityData = _.filter(availabilityData.availabilityPerDateUnit, availability => {
                    return unit ? moment(availability.date).isSame(moment(dateUnit), unit === 'week' ? 'isoWeek' : unit) : true;
                })
                const availability = this.calculateAvailability(
                    _.sumBy(correspondingAvailabilityData, 'totalTime'),
                    _.sumBy(correspondingAvailabilityData, 'totalWorkflowDownTimeUnscheduledInsideOfShifts') + _.sumBy(correspondingAvailabilityData, 'outPlannedDownTime') + _.sumBy(correspondingAvailabilityData, 'totalActivityRunTimeThatCountsAsScheduledDownTime'),
                    _.sumBy(correspondingAvailabilityData, 'totalWorkflowDownTimeUnscheduledOutsideOfShifts'),
                    _.sumBy(correspondingAvailabilityData, 'totalWorkflowDownTimeScheduledInsideOfShifts')  + _.sumBy(correspondingAvailabilityData, 'totalWorkflowDownTimeScheduledOutsideOfShifts') + _.sumBy(correspondingAvailabilityData, 'unplannedDownTime') + _.sumBy(correspondingAvailabilityData, 'plannedDownTime') + _.sumBy(correspondingAvailabilityData, 'undefinedDownTime'))
                return {dateUnit: dateUnit, availability};
            });
            return availabilityDataPerUnitDate;
        },
        getPerformanceDataPerDateUnit(performanceData, fromDate, endDate, unit) {
            const unitDates = this.getUnitDates(fromDate, endDate, unit);
            const performanceDataPerUnitDate = _.map(unitDates, dateUnit => {
                const correspondingPerformanceData = _.filter(performanceData.performancePerDateUnit, performance => {
                    return unit ? moment(performance.startOfUnit).isSame(moment(dateUnit), unit === 'week' ? 'isoWeek' : unit) : true;
                });
                const expectedOutputOnUnitTotal = _.sumBy(correspondingPerformanceData, 'expectedOutputOnUnit');
                const realOutputOnUnitTotal = _.sumBy(correspondingPerformanceData, 'realOutputOnUnit');

                const performance = this.calculatePerformance(realOutputOnUnitTotal, expectedOutputOnUnitTotal)
                return {dateUnit: dateUnit, performance};
            });
            return performanceDataPerUnitDate;
        },
        getQualityPerDateUnit(qualityData, fromDate, endDate, unit) {
            const unitDates = this.getUnitDates(fromDate, endDate, unit);
            const qualityDataPerUnitDate = _.map(unitDates, dateUnit => {
                const correspondingQualityData = _.filter(qualityData.qualityPerUnit, (value, key) => {

                    return unit ? moment(key).isSame(moment(dateUnit), unit === 'week' ? 'isoWeek' : unit) : true;
                });
                const defects = _.sumBy(correspondingQualityData, 'defects');
                const output = _.sumBy(correspondingQualityData, 'produced');

                const quality = this.calculateQuality(output, defects)
                return {dateUnit: dateUnit, quality};
            });

            return qualityDataPerUnitDate;
        },
        getOeeDataPerDateUnit(availabilityData, performanceData, qualityData, fromDate, endDate, unit) {
            const unitDates = this.getUnitDates(fromDate, endDate, unit);
            const oeeDataPerUnitDate = _.map(unitDates, dateUnit => {

                const correspondingAvailabilityData = _.filter(availabilityData.availabilityPerDateUnit, availability => {
                    return unit ? moment(availability.date).isSame(moment(dateUnit), unit === 'week' ? 'isoWeek' : unit) : true;
                })
                const totalTime = _.sumBy(correspondingAvailabilityData, 'totalTime');
                const unscheduledDownTimesWithinRange = _.sumBy(correspondingAvailabilityData, 'totalWorkflowDownTimeUnscheduledInsideOfShifts') + _.sumBy(correspondingAvailabilityData, 'outPlannedDownTime') + _.sumBy(correspondingAvailabilityData, 'totalActivityRunTimeThatCountsAsScheduledDownTime');
                const totalWorkflowDownTime = _.sumBy(correspondingAvailabilityData, 'totalWorkflowDownTimeUnscheduledOutsideOfShifts');
                const scheduledDownTimeTotal = _.sumBy(correspondingAvailabilityData, 'totalWorkflowDownTimeScheduledOutsideOfShifts') + _.sumBy(correspondingAvailabilityData, 'totalWorkflowDownTimeScheduledInsideOfShifts') + _.sumBy(correspondingAvailabilityData, 'unplannedDownTime') + _.sumBy(correspondingAvailabilityData, 'plannedDownTime') + _.sumBy(correspondingAvailabilityData, 'undefinedDownTime');
                const availability = this.calculateAvailability(totalTime, unscheduledDownTimesWithinRange, totalWorkflowDownTime, scheduledDownTimeTotal);

                const correspondingPerformanceData = _.filter(performanceData.performancePerDateUnit, performance => {
                    return unit ? moment(performance.startOfUnit).isSame(moment(dateUnit), unit === 'week' ? 'isoWeek' : unit) : true;
                });
                const expectedOutputOnUnitTotal = _.sumBy(correspondingPerformanceData, 'expectedOutputOnUnit');
                const realOutputOnUnitTotal = _.sumBy(correspondingPerformanceData, 'realOutputOnUnit');
                const performance = this.calculatePerformance(realOutputOnUnitTotal, expectedOutputOnUnitTotal)

                const correspondingQualityData = _.filter(qualityData.qualityPerUnit, (quality,index )=> {

                    return unit ? moment(index).isSame(moment(index), unit === 'week' ? 'isoWeek' : unit) : true;
                });
                const defects = _.sumBy(correspondingQualityData, 'defects');
                const output = _.sumBy(correspondingQualityData, 'produced');

                const quality = this.calculateQuality(output, defects);
                const oee = availability * performance * quality;
                return {dateUnit: dateUnit, oee};
            });
            return oeeDataPerUnitDate;
        },
        calculateOee(availability, performance, quality) {


            let oee = availability * performance * quality
            return (isNaN(oee) || !isFinite(oee)) ? 0 : oee * 100;
        },
        calculatePerformance(realOutput, expectedOutput) {
            const performance = realOutput / expectedOutput;
            return (isNaN(performance) || !isFinite(performance)) ? 0 : performance;
        },
        calculateAvailability(totalTime, unscheduledDownTimesWithinRange, totalWorkflowDownTimeOutsideOfShiftsThatAreIncludedInTheAvailability, scheduledDownTimeTotal) {
            const possibleProductionTime = totalTime - (unscheduledDownTimesWithinRange + totalWorkflowDownTimeOutsideOfShiftsThatAreIncludedInTheAvailability);
            const productionTime = possibleProductionTime - scheduledDownTimeTotal;
            const availability = productionTime / possibleProductionTime;
            return (isNaN(availability) || !isFinite(availability)) ? 0 : availability;
        },
        calculateQuality(output, defects) {

            const quality = (1 - (defects / (defects + output)));
            return (isNaN(quality) || !isFinite(quality)) ? 0 : quality;
        }
    }

}